import { render, staticRenderFns } from "./TaskInputSelect.vue?vue&type=template&id=6deb5138"
import script from "./TaskInputSelect.vue?vue&type=script&lang=js"
export * from "./TaskInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports